import * as React from "react";
import SingleMenu from "../layouts/components/SingleMenu";
import { routes } from "../router/router";
import { userGroups, userInfo } from "../lib/userInfo/userInfo";
import { myNotificationSettingsGET } from "./api";

// The "Notifications" entry on the left menu. Admin logins always see it;
// everyone else sees it once the office has switched push on for her account
// (one GET on first render, nothing else changes for those who have not).

export default class PushMenuItem extends React.Component {
	state = { show: userInfo().userGroupId === userGroups.admin };

	componentDidMount() {
		if (this.state.show) return;
		myNotificationSettingsGET()
			.then(r => this.setState({ show: !!(r.data && r.data.push_access) }))
			.catch(() => {});
	}

	render() {
		if (!this.state.show) return null;
		return <SingleMenu heading="NOTIFICATIONS" icon="fas fa-bell" route={routes.NotificationSettings} />;
	}
}
